import type { Box } from '$lib/types/Components/SharedTypes';

export enum VideoType {
    Custom = 'custom',
    ThirdParty = 'thirdparty',
}

export interface VideoContent {
    box: Box;
    video: string;
    autoplay: boolean;
    videoType?: VideoType;
    customVideoUrl?: string;
    thumbnail?: string;
    showSubtitles?: boolean;
}
